import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')
const TheContainer_Landing = () => import('@/containers/TheContainer_Landing.vue')
const TheContainer_Project = () => import('@/containers/TheContainer_Project')


// Views
// const Dashboard = () => import('@/views/Dashboard')


const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Switches = () => import('@/views/base/Switches')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tables = () => import('@/views/tables/Tables')
const AdvancedTables = () => import('@/views/tables/AdvancedTables')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Editors
const TextEditors = () => import('@/views/editors/TextEditors')
const CodeEditors = () => import('@/views/editors/CodeEditors')

// Views - Forms
const BasicForms = () => import('@/views/forms/Forms')
const AdvancedForms = () => import('@/views/forms/AdvancedForms')
const ValidationForms = () => import('@/views/forms/ValidationForms')

// Views GoogleMaps
const GoogleMaps = () => import('@/views/GoogleMaps')

// Views - Icons
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
const Brands = () => import('@/views/icons/Brands')
const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')
const Toaster = () => import('@/views/notifications/Toaster')


// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

// Plugins
const Draggable = () => import('@/views/plugins/Draggable')
const Calendar = () => import('@/views/plugins/Calendar')
const Spinners = () => import('@/views/plugins/Spinners')

// Views - UI Kits
const Invoice = () => import('@/views/apps/invoicing/Invoice')
const Compose = () => import('@/views/apps/email/Compose')
const Inbox = () => import('@/views/apps/email/Inbox')
const Message = () => import('@/views/apps/email/Message')


//
const Dashboard = () => import('@/projects/views/dashboards/index.vue')

const SSignin = () => import('@/projects/views/settings/signin/index.vue')
const CardUser = () => import('@/projects/views/slide/components/cardUser.vue')
const InfoAll = () => import('@/projects/views/vote_Info/components/Info_School.vue')

const EMember = () => import('@/projects/views/member/index.vue')
const Vote = () => import('@/projects/views/member/components/vote.vue')
const RRegister = () => import('@/projects/views/register/index.vue')
const Home = () => import('@/projects/views/slide/index.vue')


const PdpaConsent = () => import('@/projects/views/pdpa/index.vue')

//condition
const Cunion = () => import('@/projects/views/condition/con_union.vue')
const Cnormal = () => import('@/projects/views/condition/con_normal.vue')
const CSchool = () => import('@/projects/views/condition/con_school.vue')

//register
const Runion = () => import('@/projects/views/register/components/regis_union.vue')
const Rnormal = () => import('@/projects/views/register/components/regis_normal.vue')
const RSchool = () => import('@/projects/views/register/components/regis_school.vue')

// result score user
const Resultunion = () => import('@/projects/views/result/components/result_union.vue')
const Resultnormal = () => import('@/projects/views/result/components/result_normal.vue')
const ResultSchool = () => import('@/projects/views/result/components/result_school.vue')
const Resultasso = () => import('@/projects/views/result/components/result_assosiation.vue')

//committee
const Committee_home = () => import('@/projects/views/committee/index.vue')
//request approve
const Approve = () => import('@/projects/views/committee/components/Approve.vue')
//condition edit
const Editcondition = () => import('@/projects/views/committee/components/edit_condition.vue')
//history
const Select = () => import('@/projects/views/committee/components/select.vue')

//score for committee admin
const ScoreMenu = () => import('@/projects/views/score/score_menu.vue')
const Layout = () => import('@/projects/views/settings/signin/components/BlankLayout.vue')


// //admin
const Admin_home = () => import('@/projects/views/admin/index.vue')
const Listcandidate = () => import('@/projects/views/admin/component/list_user.vue')
const AddCandidate = () => import('@/projects/views/admin/component/add_association.vue')
const PDPAEdit = () => import('@/projects/views/admin/component/edit_pdpa.vue')
 const Settime = () => import('@/projects/views/admin/component/set_time.vue')

const Center = () => import('@/projects/components/dialog/CenterLoading.vue')
Vue.use(Router)
export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      component: TheContainer_Project, // your BlankLayout
      children: [
        {
          path: '',
          name: 'StudentLogin',
          component: SSignin
        }
      ]
    },

    // 🌐 Main app with full layout
    {
      path: '/',
      component: TheContainer_Landing,
      children: [
        { path: 'home', name: 'Home', component: Home },
        { path: 'vote', name: 'Vote', component: Vote },
        { path: 'registerPage', name: 'registerPage', component: RRegister },
        { path: 'cardUser', name: 'CardUser', component: CardUser },
        { path: 'member', name: 'EMember', component: EMember },
        { path: 'pdpa/:type', name: 'PdpaConsent', component: PdpaConsent }
      ]
    },

    // Vote Info
    {
      path: '/vote',
      component: TheContainer_Landing,
      children: [
        { path: 'Info_School', name: 'VoteInfoSchool', component: InfoAll }
      ]
    },

    // Info View
    {
      path: '/infomation',
      component: TheContainer_Landing,
      children: [
        { path: 'Info_School', name: 'InfoSchool', component: InfoAll }
      ]
    },

    // Condition Pages
    {
      path: '/condition',
      component: TheContainer_Landing,
      children: [
        { path: 'condition_union', name: 'Cunion', component: Cunion },
        { path: 'condition_normal', name: 'Cnormal', component: Cnormal },
        { path: 'condition_school', name: 'CSchool', component: CSchool }
      ]
    },

    // Result Pages
    {
      path: '/result',
      component: TheContainer_Landing,
      children: [
        { path: 'result_union', name: 'Resultunion', component: Resultunion },
        { path: 'result_normal', name: 'Resultnormal', component: Resultnormal },
        { path: 'result_school', name: 'ResultSchool', component: ResultSchool },
        { path: 'result_assosiation', name: 'Resultasso', component: Resultasso }
      ]
    },

    // Register Pages
    {
      path: '/register',
      component: TheContainer_Landing,
      children: [
        { path: 'register_union', name: 'Runion', component: Runion },
        { path: 'register_normal', name: 'Rnormal', component: Rnormal },
        { path: 'register_school', name: 'RSchool', component: RSchool }
      ]
    },

    // Committee Pages
    {
      path: '/committee',
      component: TheContainer_Landing,
      redirect: '/committee/committee_home',
      children: [
        {
          path: 'committee_home',
          component: Committee_home,
          children: [
            { path: '', redirect: 'Approve' },
            { path: 'Approve', name: 'approve', component: Approve },
            { path: 'score_candidate', name: 'ScoreMenu', component: ScoreMenu },
            { path: 'edit_condition', name: 'editCondition', component: Editcondition }
          ]
        }
      ]
    },

    // Admin Pages
    {
      path: '/admin',
      component: TheContainer_Landing,
      redirect: '/admin/admin_home',
      children: [
        {
          path: 'admin_home',
          component: Admin_home,
          children: [
            { path: '', redirect: 'list_user' },
            { path: 'list_user', name: 'AdminUserList', component: Listcandidate },
            { path: 'edit_pdpa', name: 'AdminPDPAEdit', component: PDPAEdit },
            { path: 'add_association', name: 'AdminAddAssociation', component: AddCandidate },
            { path: 'set_time', name: 'AdminSetTime', component: Settime },
            { path: 'score_candidate', name: 'ScoreMenu', component: ScoreMenu }
          ]
        }
      ]
    },
    {
      path: '/dashboard',
      redirect: 'dashboard/dashboard',
      name: 'Home',
      component: TheContainer_Landing,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'CenterLoading',
          name: 'Center',
          component: Center
        },


        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'tables',
          redirect: '/tables/tables',
          name: 'Tables',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'tables',
              name: 'Basic tables',
              component: Tables
            },
            {
              path: 'advanced-tables',
              name: 'Advanced tables',
              component: AdvancedTables
            }
          ]
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'users',
          meta: { label: 'Users'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User
            }
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'editors',
          redirect: '/editors/text-editors',
          name: 'Editors',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'text-editors',
              name: 'Text Editors',
              component: TextEditors
            },
            {
              path: 'code-editors',
              name: 'Code Editors',
              component: CodeEditors
            }
          ]
        },
        {
          path: 'forms',
          redirect: '/forms/basic-forms',
          name: 'Forms',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'basic-forms',
              name: 'Basic Forms',
              component: BasicForms
            },
            {
              path: 'advanced-forms',
              name: 'Advanced Forms',
              component: AdvancedForms
            },
            {
              path: 'validation-forms',
              name: 'Form Validation',
              component: ValidationForms
            }
          ]
        },
        {
          path: 'google-maps',
          name: 'Google Maps',
          component: GoogleMaps
        },
        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'CoreUI Icons',
              component: CoreUIIcons
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            },
            {
              path: 'brands',
              name: 'Brands',
              component: Brands
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            },
            {
              path: 'toaster',
              name: 'Toaster',
              component: Toaster
            }
          ]
        },
        {
          path: 'plugins',
          redirect: '/plugins/draggable',
          name: 'Plugins',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'draggable',
              name: 'Draggable Cards',
              component: Draggable
            },
            {
              path: 'calendar',
              name: 'Calendar',
              component: Calendar
            },
            {
              path: 'spinners',
              name: 'Spinners',
              component: Spinners
            }
          ]
        },

        {
          path: 'apps',
          name: 'Apps',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'invoicing',
              redirect: '/apps/invoicing/invoice',
              name: 'Invoicing',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'invoice',
                  name: 'Invoice',
                  component: Invoice
                }
              ]
            },
            {
              path: 'email',
              redirect: '/apps/email/inbox',
              name: 'Email',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'compose',
                  name: 'Compose',
                  component: Compose
                },
                {
                  path: 'inbox',
                  name: 'Inbox',
                  component: Inbox
                },
                {
                  path: 'message',
                  name: 'Message',
                  component: Message
                }
              ]
            }
          ]
        }
      ]
    },


    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
})
